//
// Module for the Employer Reporting Maintenance Index view
//
rs.module("content/employer/reporting/maintenance/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls, deletedTransmittalBatchKey) {

            // Unpack Js Selectors
            var filter = $.js(jsSelectors.filter);

            var workingBatchDropDown = filter.js(jsSelectors.workingBatchDropDown);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Listen for drop down select change
            workingBatchDropDown.change(function () {

                loadingSpinner.show();

                $.getJSON(
                    backendUrls.determineBatchEmploymentKey,
                    {
                        transmittalBatchKey: workingBatchDropDown.val(),
                        deletedKey: deletedTransmittalBatchKey

                    }).done(function (data) {

                        if (!data.isSameEmployer) {
                            // redirect to new url
                            window.location.href = data.indexUrl;
                        }
                        else {
                            // Update the grid
                            gridModule.update(
                                backendUrls.getTransmittalBatchGrid,
                                {
                                    transmittalBatchKey: workingBatchDropDown.val(),
                                    deletedKey: deletedTransmittalBatchKey
                                },
                                lrsGridApi.agGridApi,
                                function done(gridUpdate) {
                                    loadingSpinner.hide();
                                }
                            );
                        }
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);